// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Nullable from "../Data.Nullable/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Restaumatic_Services_Storage from "../Restaumatic.Services.Storage/index.js";
var setJSONItem = function (dictEncode) {
    return function (v) {
        return function (value) {
            return $foreign.setItem(v)(Foreign_Generic.encodeJSON(dictEncode)(value));
        };
    };
};
var getJSONItem = function (dictDecode) {
    return function (v) {
        return function __do() {
            var nullable_json = $foreign.getItem(v)();
            var v1 = Data_Nullable.toMaybe(nullable_json);
            if (v1 instanceof Data_Maybe.Just) {
                var v2 = Control_Monad_Except.runExcept(Foreign_Generic.decodeJSON(dictDecode)(v1.value0));
                if (v2 instanceof Data_Either.Left) {
                    Effect_Class.liftEffect(Effect_Class.monadEffectEffect)(Effect_Console.log("Error decoding localStorage." + (v + ("\x0a - Error: " + (Data_Show.show(Data_List_Types.showNonEmptyList(Foreign.showForeignError))(v2.value0) + ("\x0a - Value: " + v1.value0))))))();
                    return Data_Maybe.Nothing.value;
                };
                if (v2 instanceof Data_Either.Right) {
                    return new Data_Maybe.Just(v2.value0);
                };
                throw new Error("Failed pattern match at Restaumatic.Services.Storage.LocalStorageWithFallback (line 27, column 7 - line 37, column 28): " + [ v2.constructor.name ]);
            };
            if (v1 instanceof Data_Maybe.Nothing) {
                return Data_Maybe.Nothing.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Services.Storage.LocalStorageWithFallback (line 24, column 3 - line 40, column 19): " + [ v1.constructor.name ]);
        };
    };
};
var localStorageWithFallback = /* #__PURE__ */ (function () {
    return new Restaumatic_Services_Storage.Storage(function (dictDecode) {
        return getJSONItem(dictDecode);
    }, function (dictEncode) {
        return setJSONItem(dictEncode);
    });
})();
export {
    localStorageWithFallback
};
//# sourceMappingURL=index.js.map
